import React, { useState } from 'react';
import { FiX, FiDownload } from 'react-icons/fi';
import { useLens } from './LensContext';
import SectionHeader from './SectionHeader';
import './About.css';
import productResume from './img/resume-product.pdf';
import developerResume from './img/resume-developer.pdf';
import profileImg from './img/about.jpeg';

function About() {
  const { lens } = useLens();
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [selectedResume, setSelectedResume] = useState(null);

  const handleResumeClick = (resumeFile) => {
    setSelectedResume(resumeFile);
    setShowResumeModal(true);
  };

  return (
    <>
      <SectionHeader index="01" label="Abstract" title="About the author" />

      <div className="about-content">
        <div className="about-text reveal">
          <p className="about-lede">
            A product engineer who refuses to pick a side.
          </p>
          <p>
            I'm <strong>Tanmay Rajurkar</strong>. I've led product and operations as CPO at
            Reltin, and I've shipped production systems as a full-stack &amp; AI engineer:
            RAG pipelines for oceanographic research, ML-driven smart parking, and two
            Smart India Hackathon national wins against 68,766 and 49,000+ teams.
          </p>
          <p>
            The blend is the point: strategy that ignores engineering reality ships late,
            and engineering that ignores the user ships the wrong thing. Whether the
            artifact is a roadmap, a supply chain, or a React codebase, I work the whole
            distance from insight to deploy.
          </p>

          <div className="resume-files">
            <span className="mono-label">Attachments · pick your lens</span>
            <button
              onClick={() => handleResumeClick(productResume)}
              className={`resume-file ${lens === 'strategist' ? 'resume-file--active' : ''}`}
            >
              <span className="resume-file-name">resume-product.pdf</span>
              <span className="resume-file-note">Product resume</span>
              <FiDownload aria-hidden="true" />
            </button>
            <button
              onClick={() => handleResumeClick(developerResume)}
              className={`resume-file ${lens === 'builder' ? 'resume-file--active' : ''}`}
            >
              <span className="resume-file-name">resume-developer.pdf</span>
              <span className="resume-file-note">Developer resume</span>
              <FiDownload aria-hidden="true" />
            </button>
          </div>
        </div>

        <figure className="about-figure reveal">
          <div className="about-figure-frame">
            <img src={profileImg} alt="Tanmay Rajurkar" />
          </div>
          <figcaption className="mono-label">fig. 00 · the author</figcaption>
        </figure>
      </div>

      {/* Resume Modal */}
      {showResumeModal && (
        <div className="pdf-modal-overlay" onClick={() => setShowResumeModal(false)}>
          <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="pdf-modal-close" onClick={() => setShowResumeModal(false)}>
              <FiX />
            </button>
            <iframe
              src={selectedResume}
              width="100%"
              height="100%"
              title="Resume Viewer"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default About;
